import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import { get } from 'lodash';
export default {
  name: 'DeviceTemplateCopyWizard',
  mixins: [iconsMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    sourceTemplate: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      formValid: false,
      createServerRequest: false,
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      copyPayload: {
        title: '',
        tenantId: null,
        parentId: null
      },
      selectedBridge: null,
      bridgeTypes: [],
      deviceBridgesForAccount: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    deviceDriverLabel() {
      if (!this.sourceTemplate) {
        return '';
      }
      return `${get(this.sourceTemplate, 'devicedriver.title', '')} (${get(this.sourceTemplate, 'deviceDriverVersion', '')})`;
    }
  },
  watch: {
    isOpen: {
      handler(val) {
        if (val) {
          this.initializeForm();
        }
      },
      immediate: true
    },
    'copyPayload.tenantId'() {
      this.fetchParents();
      this.fetchBridges();
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    initializeForm() {
      this.copyPayload = {
        title: `${get(this.sourceTemplate, 'title', '')} (copy)`,
        tenantId: get(this.sourceTemplate, 'tenantId', null),
        parentId: get(this.sourceTemplate, 'parentId', null)
      };
      this.selectedBridge = null;
      this.deviceBridgesForAccount = [];
      this.bridgeTypes = [];
      this.formValid = false;
      this.fetchBridges();
    },
    parentSelectorFilter(item) {
      return item.tenantId === this.copyPayload.tenantId;
    },
    async fetchParents() {
      if (!this.copyPayload.tenantId) {
        return;
      }
      const sourceTenantId = get(this.sourceTemplate, 'tenantId', null);
      try {
        const result = await ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, this.copyPayload.tenantId);
        const newParentId = get(result, 'digitaltwins[0].id', null);
        const parentIdIsEmpty = !this.copyPayload.parentId;
        const tenantChangedFromSource = this.copyPayload.tenantId !== sourceTenantId;
        if (parentIdIsEmpty || tenantChangedFromSource) {
          this.copyPayload.parentId = newParentId;
        }
      } catch (error) {
        console.error('Error fetching parents', error);
      }
    },
    async fetchBridges() {
      this.selectedBridge = null;
      this.deviceBridgesForAccount = [];
      if (!this.copyPayload.tenantId) {
        return;
      }
      try {
        const [bridgeTypes, bridges] = await Promise.all([ApiService.getBridgeTypes().then(types => {
          return types.filter(type => {
            return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
          });
        }), ApiService.getBridgesForTenant(this.copyPayload.tenantId)]);
        this.bridgeTypes = bridgeTypes;
        this.deviceBridgesForAccount = bridges.filter(bridgeInstance => {
          const bridgeTypeDef = bridgeTypes.find(bridgeDef => bridgeDef.type === bridgeInstance.type);
          return get(bridgeTypeDef, 'manifest.functionScope.extension.devices.create') || get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read');
        });
        this.selectedBridge = this.deviceBridgesForAccount.find(bridge => bridge.id === get(this.sourceTemplate, 'deviceMeta.connectorId')) || null;
      } catch (error) {
        this.$snack(this.$i18n_t('Connectors.Connectors.errors.connectionError'), 'error');
        console.error('Error fetching bridges', error);
      }
    },
    async save() {
      if (!this.sourceTemplate || !this.selectedBridge) {
        return;
      }
      this.createServerRequest = true;
      try {
        const res = await ApiService.deviceTemplateCopy(this.sourceTemplate.id, {
          ...this.copyPayload,
          connectorId: this.selectedBridge.id
        });
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.copySuccess'), 'success');
        if ((res.warnings || []).length > 0) {
          this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.copyWarnings'), 'warning');
        }
        this.$emit('created', res);
      } catch (error) {
        if (error.response && this.$i18n_te(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.copyError'), 'error');
        }
      } finally {
        this.createServerRequest = false;
      }
    }
  }
};